import { useState } from "react";
import { BlockTitle } from "@blocks/Blocks";
import Ad from "@components/Advertisement/Ad";
import Container from "@components/Container/Container";
import { GADataProps } from "@components/GAData/GAData";
import IconFactory from "@components/Icon/IconFactory";
import { IconTypeEnum } from "@components/Icon/utils/types";
import EventsAwardsHeader from "@events-awards/components/EventAwardsHeader";
import EventsAwardsFooter from "@events-awards/components/EventsAwardsFooter";
import EventsAwardsNavigationBar from "@events-awards/components/EventsAwardsNavigationBarComponents/EventAwardsNavigationBar";
import { useInjectClientData } from "@hooks/useInjectClientData";

import WinnersParagraphComponent from "./components/WInnersParagraphComponent";
import WinnersTab from "./components/WinnersTab";
import { EventsAwardsWinnersPageData } from "./utils/types";

/**
 * Component to render event awards winners page content
 */
const EventsAwardsWinnerPageContent = ({
  articles,
  awardType,
  gaProps,
}: EventsAwardsWinnersPageData & {
  gaProps: GADataProps;
}): React.ReactElement => {
  useInjectClientData({ gaProps });

  const [showTabs, setShowTabs] = useState(false);

  const years = articles.map(({ title }) => title);
  const [selectedYear, setSelectedYear] = useState(years[0]);

  return (
    <div
      className="min-h-screen w-full"
      data-testid="events-awards-winners-page-content-component"
    >
      <EventsAwardsHeader />

      <Container>
        <EventsAwardsNavigationBar awardType={awardType} />

        <div className="-mx-0 mb-8 w-full bg-gray-150 px-6 py-4 font-public-sans">
          <button
            onClick={() => {
              setShowTabs(!showTabs);
            }}
            className="mb-2 flex items-center gap-2 text-left text-2xl font-bold focus:outline-none"
          >
            <BlockTitle
              text={selectedYear}
              rootClassName="text-4xl md:text-6xl font-medium lg:text-8xl hover:underline"
            />

            <IconFactory
              type={IconTypeEnum.arrowDown}
              x={30}
              y={23}
              size={50}
            />
          </button>

          {showTabs ? (
            <WinnersTab
              selectedYear={selectedYear}
              setSelectedYear={setSelectedYear}
              setShowTabs={setShowTabs}
              years={years}
            />
          ) : null}

          <WinnersParagraphComponent
            selectedYear={selectedYear}
            articles={articles}
          />
        </div>
      </Container>

      <EventsAwardsFooter awardType={awardType} />

      <Ad adType="catfish" />

      <Ad adType="prestitial" />
    </div>
  );
};

export default EventsAwardsWinnerPageContent;
